import React from "react";
import cx from "classnames";
import { upperFirst } from "lodash-es";

import { polymorphic } from "../utils";
import styles from "./link.module.scss";
import IconContainer from "../IconContainer/IconContainer";

export namespace Link {
  export type Props = {
    as?: "a" | "button";
    className?: string;
    icon?: React.ElementType;
    iconAffix?: "prefix" | "suffix";
    theme?: "primary" | "secondary" | "tertiary";
  };
}

export const Link = polymorphic("a")<Link.Props>(
  ({
    as: Component,
    children,
    className,
    icon,
    iconAffix = "prefix",
    theme = "primary",
    ...props
  }) => {
    const classList = cx(
      className,
      styles.link,
      icon && children && styles.linkHasIconAffix,
      styles[`linkIcon${upperFirst(iconAffix)}` as keyof typeof styles],
      styles[`link${upperFirst(theme)}` as keyof typeof styles]
    );

    return (
      <Component {...props} className={classList}>
        {icon && (
          <IconContainer icon={icon} className={styles.linkIconContainer} />
        )}
        {children}
      </Component>
    );
  }
);
